export default __webpack_public_path__ + "static/media/docker.56f0d51c.png";